import styled from 'styled-components';
import { CheckConfirmedIcon, FailIcon, InfoIcon } from './autoCheckReportIcons';
import { useMemo } from 'react';
import { useDeviceInfo } from 'hooks/useDeviceInfo';
import { AutoCheckItem } from './types';

type Props = AutoCheckItem;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;
`;

const Divider = styled.div`
  flex-grow: 1;
`;

const Label = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  min-width: fit-content;
`;

const Value = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #225a91;
  min-width: fit-content;
  text-transform: capitalize;
`;

const IconContainer = styled.div`
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  display: flex;
  outline: 1px solid #cccccccc;
  border-radius: 8px;
`;

const InfoIconContainer = styled.div<{ $hasAction: boolean }>`
  cursor: ${props => (props.$hasAction ? 'pointer' : 'default')};
  position: relative;
  display: flex;
`;

const BottomSubText = styled.div`
  position: absolute;
  bottom: -14px;
  left: 0;
`;

const SubText = styled.div`
  font-size: 10px;
  color: #00000099;
  min-width: fit-content;
`;

const subIconMap = {
  success: CheckConfirmedIcon,
  fail: FailIcon,
  info: InfoIcon
};

export const AutoCheckPreviewRow = ({
  Icon,
  label,
  value,
  subText,
  subTextPosition,
  openPopup,
  closePopup,
  PopupComponent,
  iconType = 'success'
}: Props) => {
  const SubIcon = subIconMap[iconType];

  const { isMobile } = useDeviceInfo();
  const listeners = useMemo(() => {
    if (isMobile) return { onClick: openPopup };
    return { onMouseOver: openPopup, onMouseLeave: closePopup };
  }, [isMobile, openPopup, closePopup]);

  return (
    <Wrapper>
      <IconContainer>
        <Icon />
      </IconContainer>
      <Label>{label}</Label>
      {subText && subTextPosition !== 'bottom' && <SubText>{subText}</SubText>}
      <Divider />
      <Value>{value}</Value>
      <InfoIconContainer $hasAction={!!openPopup} {...listeners}>
        <SubIcon />
        {PopupComponent && <PopupComponent />}
      </InfoIconContainer>
      {subText && subTextPosition === 'bottom' && (
        <BottomSubText>
          <SubText>{subText}</SubText>
        </BottomSubText>
      )}
    </Wrapper>
  );
};
